import React from "react";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";

const Content = styled(Box)(({ theme }) => ({
  margin: 'auto',
  maxWidth: '500px',
}));

const AvatarContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  marginBottom: theme.spacing(1.75),
  '& > *': {
    margin: theme.spacing(0.5),
  },
}));

const AvatarLabel = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
}));

function AvatarWithText({user}) {
  return (
    <AvatarContainer sx={{ marginTop: 1.5 }}>
      <AvatarLabel sx={{ marginRight: 1.75 }}>
        <Typography variant="body2">{user.name}</Typography>
        <Avatar
          sx={{ marginLeft: 1 }}
          alt={user.name}
          src={user.picture}
        />
      </AvatarLabel>
    </AvatarContainer>
  );
}

function AvatarDisplay(user){
  return (
    <Content>
      <AvatarWithText {...user}/>
    </Content>
  );
};

export default AvatarDisplay;
